import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";

export const useUnassignSupervisorMentor = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      mentorId,
      supervisorId,
    }: {
      mentorId: string;
      supervisorId: string;
    }) =>
      fetchApi({
        url: `v2/mentor/${mentorId}/unassign-supervisor`,
        method: "POST",
        data: {
          supervisorId,
        },
      }),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["supervisorMentors", variables.supervisorId],
      });
    },
  });
};
